import {
    EXTRAITEMS_LOADING, GET_EXTRAITEMS_DATA_SUCCESS, GET_EXTRAITEMS_DATA_ERROR,
    GET_EXTRAITEM_OBJECT, GET_EXTRAITEM_OBJECT_AFTER_MEMBERSHIP, UPDATE_PRODUCT_QUANTITY, RESET_EXTRAITEMS, RESET_ERROR_MSG, SET_ADDTOCART
} from "../actions/actionExtraItems";
import { genfunction } from 'helpers';
import { loadState, saveState } from "../helpers/sessionStorage";

const { DefaultCostRateID } = window['runConfig'];

const sessionKey = "ExtraItem";


const initialState = {
    extramItems: [],
    extraItem: loadState(sessionKey, {}), //{},
    loading: false,
    extramItemsError: '',
    isAddToCart: false
};

function reducerExtraItems(state = initialState, action) {
    switch (action.type) {
        case EXTRAITEMS_LOADING: {
            return {
                ...state,
                loading: true,
                extramItemsError: '',
                isAddToCart: false
            };
        }

        case GET_EXTRAITEMS_DATA_SUCCESS: {

            return {
                ...state,
                loading: false,
                extramItems: action.payload,
                extramItemsError: '',
                isAddToCart: false
            };
        }
        case GET_EXTRAITEM_OBJECT: {

            let newextraItems = JSON.parse(JSON.stringify(state.extramItems));
            let extraItm = JSON.parse(JSON.stringify(state.extraItem));

            let extraItem = {};

            if (newextraItems && newextraItems.length > 0) {
                extraItem = { ...newextraItems.filter(x => x.TourEventID == action.payload)[0] };
            }
            else if (extraItm && extraItm.hasOwnProperty('TourEventID')) {
                extraItem = extraItm;
            }

            extraItem.CouponItems = [];
            let costrate = 0;

            if (genfunction.IsNotNullOrEmptyOrUndefined(action.OrganizationCostRate)) {
                costrate = action.OrganizationCostRate;
            }
            else if (action.IsMembershipApplied) {
                costrate = action.MemberCostRate;
            }
            else if (action.IsIDME) {
                costrate = action.IsIDMECostRate;
            }
            else {
                costrate = DefaultCostRateID;
            }


            if (extraItem.TourProducts && extraItem.TourProducts.length > 0) {
                extraItem.TourProducts = extraItem.TourProducts.filter(x => x.PriceMatrix !== undefined).map(e => {


                    e.IsCouponApplied = false;

                    if (!e.hasOwnProperty("Quantity")) {
                        e.Quantity = 0;
                    }
                    if (e.hasOwnProperty("PriceMatrix")) {
                        let pmatrix;

                        if (e.PriceMatrix.length > 1 && e.PriceMatrix.find(x => x.CostRateID == costrate) !== undefined)
                            pmatrix = e.PriceMatrix.find(x => x.CostRateID == costrate);
                        else
                            pmatrix = e.PriceMatrix[0];

                        e.PriceMatrix = [];
                        e.PriceMatrix.push(pmatrix);
                    }

                    return e;
                });
            }

            saveState(sessionKey, extraItem);

            return {
                ...state,
                loading: false,
                extraItem: extraItem,
                extramItemsError: '',
                isAddToCart: false
            }
        }

        case GET_EXTRAITEM_OBJECT_AFTER_MEMBERSHIP: {

            let extraItem = JSON.parse(JSON.stringify(action.payload));
            let extramItems = JSON.parse(JSON.stringify(state.extramItems));
            
            let costrate = 0;

            if (genfunction.IsNotNullOrEmptyOrUndefined(action.OrganizationCostRate)) {
                costrate = action.OrganizationCostRate;
            }
            else if (action.IsMembershipApplied) {
                costrate = action.MemberCostRate;
            }
            else if (action.IsIDME) {
                costrate = action.IsIDMECostRate;
            }
            else {
                costrate = DefaultCostRateID;
            }

            extraItem = genfunction.ApplyMembershipPricesOnTourEvent(extraItem, costrate, extramItems, DefaultCostRateID);

            saveState(sessionKey, extraItem);

            return {
                ...state,
                loading: false,
                extraItem: extraItem,
                extramItemsError: '',
                isAddToCart: false
            }
        }

        case UPDATE_PRODUCT_QUANTITY:

            let isCheckOut = false;
            let newExtraItem = { ...state.extraItem };
            newExtraItem.TourProducts = newExtraItem.TourProducts.map(e => {
                if (e.TourProductID == action.payload) {
                    e.Quantity = action.Quantity;
                    e.MaximumTickets = action.MaximumTickets;
                    e.MinimumTickets = action.MinimumTickets;
                }

                if (e.Quantity > 0 && e.AffectsCapacity) {
                    isCheckOut = true
                }

                if (action.ItemExist) {
                    isCheckOut = true;
                }

                return e;
            });

            newExtraItem = genfunction.calculateeventsamount([newExtraItem])[0]

            saveState(sessionKey, newExtraItem);

            return {
                ...state,
                loading: false,
                extraItem: newExtraItem,
                extramItemsError: '',
                isAddToCart: isCheckOut
            }

        case GET_EXTRAITEMS_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                extramItemsError: action.error

            }
        }

        case RESET_EXTRAITEMS: {

            saveState(sessionKey, {});

            return {
                ...state,
                loading: false,
                extramItemsError: '',
                isAddToCart: false,
                extramItems: [],
                extraItem: {}
            }
        }

        case RESET_ERROR_MSG: {
            return {
                ...state,
                loading: false,
                extramItemsError: ''
            }
        }

        case SET_ADDTOCART: {

            let newExtraItem = { ...state.extraItem }
            let isAddToCart;

            if (newExtraItem && newExtraItem.TourProducts && newExtraItem.TourProducts.length > 0)
                isAddToCart = newExtraItem.TourProducts.filter(p => p.Quantity > 0).length > 0 ? true : false;

            return {
                ...state,
                isAddToCart: isAddToCart
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerExtraItems;